import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { OrderReportFilters, ReportService } from "../services/reportService";

export const useOrderReports = () =>
  useQuery({
    queryKey: ["order-reports"],
    queryFn: ReportService.getReports,
    refetchInterval: (query) => {
      const reports = query.state.data || [];
      return reports.some((report) => report.status === "PENDING" || report.status === "PROCESSING")
        ? 5000
        : false;
    },
    refetchOnWindowFocus: true,
  });

export const useCreateOrderReport = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (filters: OrderReportFilters) => ReportService.createOrderReport(filters),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["order-reports"] });
    },
  });
};
